import React, { Component } from "react";
import Table from "../../../common/table/NewTable";
import { Location, History } from "history";
import { match } from "react-router";
import { onFailAction } from "../../../../helpers/SwalCommon";
import TableActionButton from "./action-button/TableActionButton";
import { TYPE_LABEL_CLASS } from "../Enum";
import { formatDateTime } from "../../../../helpers/NewCaHelper";
import DocumentService from "../../../../services/document/DocumentService";
import { onDeleteAlert, onSuccessAction } from "../../../common/swal/SwalCommon";
import {
  reloadPage
} from "../../../../helpers/NewCaHelper";
import { Tag } from "antd";

interface Props {
  location: Location;
  history: History;
  match: match;
}
interface State { }

export default class AgencyTable extends Component<Props, State> {
  state = {};
  service = new DocumentService();
  componentDidMount() {
    this.fetch();
  }

  fetch = async (params = {}) => {
    this.setState({ loading: true });
    try {
      const result = await this.service.getDocuments(params);
      return result;
    } catch (error) {
      console.log(error);
            onFailAction();
    }
  };

  onClickDeleteButton = (id) => {
    const self = this;
    onDeleteAlert(async function (willDelete) {
      if (willDelete) {
        const result = await self.service.deleteDocumentById(id);
        if (result && result.status === 200) {
          onSuccessAction('Xóa tài liệu thành công!', reloadPage(self.props.location, self.props.history));
        }
      }
    });
  }

  render() {
    return (
      <Table
        columns={this.columns}
        onFetchData={this.fetch}
      />
    );
  }

  onRenderActionColumn = (text, record, index) => {
    return (
      <TableActionButton
        onClickLock={() => this.onClickDeleteButton(record.id)}
        onClickUpdate={() =>
          this.props.history.push(`/tai-lieu/cap-nhat/${record.id}`)
        }
        isDisplayLockButton={true}
        isDisplayUpdateButton={true}
      />
    );
  };

  renderTypeColumn = (text) => {
    return (
      <div>
        {Object.keys(TYPE_LABEL_CLASS).map((key, index) => (
          (text.indexOf(key) > -1) ?
            <Tag key={key} color={`${TYPE_LABEL_CLASS[key].class}`}>
                {TYPE_LABEL_CLASS[key].label}
            </Tag> : ''
        ))}
      </div>
    );
  };

  columns = [
    { title: "Tên tài liệu", dataIndex: "name" },
    { title: "Số tài liệu", dataIndex: "number" },
    { title: "Ngày hiệu lực", dataIndex: "valid_at" },
    {
      title: "Hiển thị trên",
      dataIndex: "type",
      render: this.renderTypeColumn
    },
    {
      title: "Thời gian tạo",
      dataIndex: "created_at",
      render: (text) => formatDateTime(text)
    },

    {
      title: "Tác vụ",
      render: this.onRenderActionColumn
    }
  ];
}
